<template>
  <button :class="size + ' bt-' + color"
          @click="btn_click">
    {{ props.txt }}
  </button>
</template>

<script setup>
import {defineProps, defineEmits, onMounted} from 'vue';

const props = defineProps({
  txt: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'small'
  },
  color: {
    type: String,
    default: 'white'
  },
  isAuthor: {
    /* 권한에 따라 제한두기 위해 임의로 설정 */
    type: Boolean,
    default: false,
  }
});

const emits = defineEmits(['click']);

const btn_click = () => {
  emits('click');
}

onMounted(() => {
})

</script>

<style scoped>

</style>